import { useAppSelector, useUserFunctionality } from 'hooks';
import { configSelector, userLocalRolesSelector } from 'selectors';
import { getMetrikaClientId } from 'utils';
import { useExperiments } from 'yandex-metrica-ab-react';

import { getYandexMetrikaCode } from '../utils/yandexMetrika';

export const useVariocubeExperiments = () => {
  const localRoles = useAppSelector(userLocalRolesSelector);
  const user = useUserFunctionality();
  const config = useAppSelector(configSelector);

  // Вариокуб нужен только для счетчиков родителя и ученика
  const metrikaCounters = user.isParent || user.isStudent ? getYandexMetrikaCode(user, localRoles, config?.MODE) : [];
  const clientId = metrikaCounters.length ? getMetrikaClientId(metrikaCounters[0]) : undefined;
  const experimentsData = useExperiments<any>({
    clientId,
  });

  return experimentsData;
};
